import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconComponent } from '@gains-com/ui-angular';

@Component({
  selector: 'app-billing-name-warning',
  imports: [IconComponent],
  templateUrl: './billing-name-warning.component.html',
  styleUrl: './billing-name-warning.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BillingNameWarningComponent {
  fullName = input<string>('');
}
